// components/PricingInfo.jsx
import { useTranslation } from 'react-i18next';

export default function PricingInfo() {
  const { t } = useTranslation();

  return (
    <div className="mt-8 mb-10 bg-pink-50 dark:bg-gray-700 border border-pink-200 dark:border-gray-600 rounded-xl p-4 text-sm text-gray-800 dark:text-gray-100 shadow-sm">
      <p className="mb-2 font-semibold text-pink-700 dark:text-pink-300">
        💰 {t('pricing_info_title')}
      </p>
      <ul className="list-disc list-inside pl-1 space-y-1">
        <li>{t('pricing.1to5')}</li>
        <li>{t('pricing.6to11')}</li>
        <li>{t('pricing.12plus')}</li>
      </ul>
    </div>
  );
}
